export default "__VITE_ASSET__6OcV5Yk6__"